module.exports = __webpack_public_path__ + "img/about.6aa1aa0a.png";